/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:11:46
 * @LastEditors: xgx
 * @LastEditTime: 2022-12-09 11:03:59
 */
import req from "@/utils/request";
export const organTree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const create = (params) => req.post("/manager-service/m/role/create", params);
export const update = (params) => req.post("/manager-service/m/role/update", params);
export const list = (params) => req.post("/manager-service/m/role/list", params);
export const deleteFn = (params) => req.post("/manager-service/m/role/delete", params);
export const listTree = (params) => req.post("/manager-service/m/menu/listTree", params);
export const roleMenuList = (params) => req.post("/manager-service/m/roleMenu/listTree", params);
export const saveRoleMenu = (params) => req.post("/manager-service/m/roleMenu/saveRoleMenu", params);